import { RecursoEvento } from './../../entity/recurso-evento.model';
import { Component, Input, Output } from '@angular/core';
import { BaseStepComponent } from '../../base';
import { Validators, FormGroup } from '@angular/forms';



@Component({
  selector: 'resumo-evento',
  templateUrl: './resumo-evento.component.html'
})
export class ResumoEventoComponent extends BaseStepComponent {

  @Input("evento") gerenciamentoEvento: any;
  @Input() listaPntCRC: any[];
  @Input() listaPntCFC: any[];
  @Input() etapa: any;
  @Input() listaResumo: any[];
  @Input() listaRelatores: any[];
  @Input() controladorVisao = false;
  @Input() recurso_evento: RecursoEvento[] = [];

  @Input() listaFormacaoAcademico: any[] = [];
  listaFormacaoInstrutor: any[] = [];
  @Input() uploadedFiles: any[] = [];

  displayInstrutorModal: boolean;
  modal_obj: any;
  displayConteudoModal: boolean;

  @Input('form') cadastro: FormGroup;
  @Input() mostrarGestor: boolean;
  modal: number;
  @Input() deferido: string;
  textoDeferimento: string = '';
  @Input() anos: string;
  @Input() nomeCapacitadora: string;
  @Input() habilitaCamposPontuacao: boolean;
  @Input() decisaoComissaoCrc: any;
  @Input() disabledCheckbox: any;

  @Input() acao: string;

  showDialog(obj, modal) {
    this.uploadedFiles = [];

    if (modal === 1) {
      this.displayInstrutorModal = true;
      this.modal_obj = obj;
      obj.instrutor.anexo_instrutor.forEach(x => {
        x.show = true;
        this.uploadedFiles.push(x);
      });
      this.listaFormacaoInstrutor = obj.instrutor.formacao_academica_instrutor;
    }

    if (modal === 2) {
      this.displayConteudoModal = true;
      this.modal_obj = obj;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/resumo-evento/resumo-evento.component.ts